import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Page, Pane, PaneBackButton, PaneBody, PaneHeader } from '../../atoms/applications/page';
import './homeLocationSelectionPane.module.scss';
import { HomeLocationSelector } from '../home_locations/HomeLocationSelector';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { ApplicationPaneHeader } from '../../atoms/applications/ApplicationPaneHeader';
import { BaseApplicationPageState } from '../../../containers/application/states/BaseApplicationPageState';

type Props = {
  applicationState: BaseApplicationPageState;
};

export const ApplicationPageHomeLocationSelectionPane = inject('applicationState')(
  observer(
    class ApplicationPageHomeLocationSelectionPane extends React.Component<Props> {
      render() {
        const {
          applicationState: {
            canGoBack,
            name,
            selectedLocationId,
            selectHomeLocation,
            validateHomeLocationAndNext,
            baseListState: { baseList },
            userState: {
              homeLocation: { isCurrentLocationOnline },
            },
            submitState: { submitting },
          },
        } = this.props;
        return (
          <Page>
            <Pane>
              {canGoBack && <PaneBackButton />}
              <ApplicationPaneHeader plan={name} />
              <PaneHeader>ホーム拠点の選択</PaneHeader>
              <PaneBody>
                <div styleName="text">
                  ご都合に合わせてどの拠点もご自由にお使いいただけますが、スムーズな運営を行うために最も多く利用する予定の拠点(ホーム拠点)の選択をしてください。
                  どの拠点を選択いただいても全ての拠点利用が可能なのでご安心ください。
                  また、ホーム拠点はマイページからいつでも変更することができます。
                </div>
                <div styleName="body">
                  <HomeLocationSelector
                    currentLocationOnline={isCurrentLocationOnline}
                    selectedLocationId={selectedLocationId}
                    onSelect={selectHomeLocation}
                    locations={baseList}
                  />
                  <div styleName="button-wrapper">
                    <Button
                      id="home-location-submit"
                      type="primary"
                      size="l"
                      styleName="button"
                      disabled={selectedLocationId != null && selectedLocationId < 0}
                      onClick={validateHomeLocationAndNext}
                      loading={submitting}
                    >
                      プランの選択へ
                    </Button>
                  </div>
                </div>
              </PaneBody>
            </Pane>
          </Page>
        );
      }
    }
  )
);
